import { permissionService } from "../core";
import type { PermissionType } from "../types";

/**
 * 通用的权限检查帮助函数
 */
export const checkPermission = (
  permission: string | number,
  type: PermissionType = "system"
): boolean => {
  return permissionService.checkPermission(permission, type);
};

/**
 * 创建权限检查高阶函数
 */
export const createPermissionChecker = (type: PermissionType) => {
  return (permission: string | number) => checkPermission(permission, type);
};

/**
 * 权限检查器工厂
 */
export const permissionCheckers = {
  system: createPermissionChecker("system"),
  function: createPermissionChecker("function"),
  export: createPermissionChecker("export"),
};

/**
 * 批量权限检查
 */
export const checkMultiplePermissions = (
  permissions: Array<{ permission: string | number; type?: PermissionType }>,
  mode: "any" | "all" = "any"
): boolean => {
  const results = permissions.map(({ permission, type = "system" }) =>
    checkPermission(permission, type)
  );

  return mode === "any" ? results.some(Boolean) : results.every(Boolean);
};

/**
 * 权限验证装饰器（用于类方法）
 */
export const requirePermission = (
  permission: string | number,
  type: PermissionType = "system"
) => {
  return (
    _target: any,
    propertyKey: string,
    descriptor: PropertyDescriptor
  ) => {
    const originalMethod = descriptor.value;

    descriptor.value = function (...args: any[]) {
      if (!checkPermission(permission, type)) {
        console.warn(`权限不足，无法执行方法 ${propertyKey}`);
        return;
      }
      return originalMethod.apply(this, args);
    };

    return descriptor;
  };
};
